import { Route, Routes } from 'react-router-dom'

import { AppShell } from '@/components/layout/AppShell'
import { MeProvider } from '@/context/MeProvider'
import { AdminPage } from '@/pages/AdminPage'
import { DiscoverPage } from '@/pages/DiscoverPage'
import { DropPage } from '@/pages/DropPage'
import { HomePage } from '@/pages/HomePage'
import { SignInPage } from '@/pages/SignInPage'
import { SignUpPage } from '@/pages/SignUpPage'
import { StashPage } from '@/pages/StashPage'
import { SupportPage } from '@/pages/SupportPage'
import { WelcomePage } from '@/pages/WelcomePage'

export default function App() {
  return (
    <MeProvider>
      <Routes>
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/sign-up/*" element={<SignUpPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/drop" element={<DropPage />} />
          <Route path="/stash" element={<StashPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </MeProvider>
  )
}
